import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useAppDispatch } from "@store/store-helper";
import { useSearchParams } from "react-router-dom";

/** Function type for handling feature toggle state changes */

/** Function type for creating feature toggle handlers */

/** Function type for updating URL search parameters */

/**
 * Custom hook for managing feature toggle state
 */
export function useFeatureToggle() {
  const $ = _c(9);
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams || $[1] !== setSearchParams) {
    t0 = (queryParam, isEnabled) => {
      const params = new URLSearchParams(searchParams);
      const existingParam = [...params.keys()].find(key => key.toLowerCase() === queryParam.toLowerCase());
      if (existingParam) {
        params.delete(existingParam);
      }
      if (isEnabled) {
        params.set(queryParam, "true");
      }
      setSearchParams(params);
    };
    $[0] = searchParams;
    $[1] = setSearchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const updateSearchParams = t0;
  let t1;
  if ($[3] !== dispatch || $[4] !== updateSearchParams) {
    t1 = t2 => {
      const {
        setEnabledAction,
        queryParam: queryParam_0
      } = t2;
      return isEnabled_0 => {
        dispatch(setEnabledAction(isEnabled_0));
        updateSearchParams(queryParam_0, isEnabled_0);
      };
    };
    $[3] = dispatch;
    $[4] = updateSearchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const createToggleHandler = t1;
  let t2;
  if ($[6] !== createToggleHandler || $[7] !== updateSearchParams) {
    t2 = {
      createToggleHandler,
      updateSearchParams
    };
    $[6] = createToggleHandler;
    $[7] = updateSearchParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}